import {
  Card,
  CardHeader,
  CircularProgress,
  Grid,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { DateTime } from 'luxon';
import React from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import useCustomerTires from 'core/hooks/useCustomerTires';
import { useSchemaMeta } from 'Elements/Form/Schema';
import currency from 'Elements/Formats/currency';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import OverflowScroll from 'Elements/GridTable/OverflowScroll';

const Row = styled(GridRow)`
  grid-template-columns: auto 60px 60px 100px 100px;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
`;

function CustomerTiresTable() {
  const { customerId } = useSchemaMeta<{ customerId: number }>();
  const { tires, tireMeta, loading } = useCustomerTires(customerId);

  return (
    <Card elevation={1}>
      <CardHeader title="Renkaat" />
      <Grid container direction="row" justify="center" spacing={2}>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <Typography variant="h6">
                {tireMeta ? tireMeta.stock_count : '-'} kpl
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="overline">Rengasta varastossa</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <Typography variant="h6">
                {currency.format(tireMeta ? tireMeta.stock_value : 0)}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="overline">Varastoarvo</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <GridTable>
        <Header>
          <Row>
            <Column>Nimi</Column>
            <Column>Ura</Column>
            <Column>Arvo</Column>
            <Column>Lokaatio</Column>
            <Column>Viim. poisto</Column>
          </Row>
        </Header>

        <Body>
          <OverflowScroll height="235px">
            {tires.map((tire) => (
              <Row hover>
                <Column>{tire.name}</Column>
                <Column>{tire.track_depth} mm</Column>
                <Column>{currency.format(tire.stock_value)}</Column>
                <Column>{tire.location}</Column>
                <Column>
                  <Tooltip title={tire.latest_dismount.description}>
                    <span>
                      {tire.latest_dismount.created_at &&
                        DateTime.fromISO(
                          tire.latest_dismount.created_at
                        ).toFormat('dd.MM.yyyy')}
                    </span>
                  </Tooltip>
                </Column>
              </Row>
            ))}

            {tires.length === 0 && (
              <Row>
                <CenterColumn>
                  {loading && <CircularProgress />}

                  {!loading && tires.length === 0 && (
                    <Typography variant="subtitle1">
                      Asiakkaalla ei ole renkaita
                    </Typography>
                  )}
                </CenterColumn>
              </Row>
            )}
          </OverflowScroll>
        </Body>
      </GridTable>
    </Card>
  );
}

export default withRouter(CustomerTiresTable);
